import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { AdminService } from '../services/admin.service';
import { UserService } from '../services/user.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: 'app-resetadminblockdialog',
    templateUrl: './resetadminblockdialog.component.html',
    styleUrls: ['./resetadminblockdialog.component.css']
})
export class ResetAdminBlockDialog {
    element: any = {};
    myForm: any = FormControl;
    constructor(
        public dialogRef: MatDialogRef<ResetAdminBlockDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public adminService: AdminService,
        public userService: UserService,
        public notificationService: NotificationsService,
        public spinnerService: Ng4LoadingSpinnerService,
    ) {
        this.element = data;
        this.myForm = this.fb.group({
            password: ['', [Validators.required]],
        });
    }
    resetBlock() {
        if (this.myForm.valid) {
            this.userService.csrf().subscribe(csdata => {
                this.spinnerService.show();
                this.adminService.resetAdminBlock({
                    _id: this.element._id,
                    password: this.myForm.value.password,
                    _csrf: csdata._csrf
                }).subscribe(data => {
                    this.spinnerService.hide();
                    this.notificationService.success('Success', data.message, {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    });
                    this.dialogRef.close({ success: true });
                }, (err) => {
                    this.spinnerService.hide();
                    this.notificationService.error('Error', err.error.message);
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/resetadminblockdialog/resetadminblockdialog.component.ts